import { testLocalhost } from "../constants/defaultValues";

const CheckApi = (status = "", item = {}, token = "") => {
    const statusCheckApi = testLocalhost
    if (statusCheckApi) console.log(status, item, token)

    // return console.log(text) false
}

export default CheckApi;